import { toast } from '@solinkcorp/solink-components';
import useLocale from 'src/hooks/useLocale';
import useSWR from 'swr';
import LocaleUtil from 'utils/LocaleUtil';
import * as SaveClipUtils from '../../utils/saveClipUtils';

const PULLING_INTERVAL = 5000;

// Get the status of the clip video pushing to cloud for the camera
const useCloudDownload = ({
  eventId,
  cameraId,
  cameraName,
  streamId,
  tenantId,
  shouldRefreshCloudDownload,
}: {
  eventId?: string;
  cameraId: string;
  cameraName: string;
  streamId: string;
  tenantId: string;
  shouldRefreshCloudDownload: boolean;
}) => {
  const locale = useLocale();

  const { data: cloudDownload } = useSWR(
    eventId ? ['cloudDownload', eventId, cameraId, cameraName, streamId] : null,
    async ([, eventId, cameraId, cameraName, streamId]) => {
      const response = await SaveClipUtils.checkDownloadReady({
        eventId,
        cameraId,
        cameraName,
        streamId,
        tenantId,
      });
      return response;
    },
    {
      refreshInterval: shouldRefreshCloudDownload ? PULLING_INTERVAL : 0,
      onError: (error) =>
        toast.error(
          `${LocaleUtil.getLocalizedStr({
            string: locale.error.unableToCheckDownloadStatus,
            replacements: { cameraName },
          })} ${error}`,
        ),
    },
  );

  return { cloudDownload };
};

export default useCloudDownload;
